module.exports = __webpack_public_path__ + "static/media/LightUpTheDarkness.537afcfa.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/Motivation/LightUpTheDarkness/LightUpTheDarkness.mp4
// module id = 383
// module chunks = 0